// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bViK","placeholdersHeader":"styles_placeholdersHeader__11ekx","editorStyle":"styles_editorStyle__mm5mL","placeholdersBox":"styles_placeholdersBox__1Dfk-"};